import React, { createContext, Dispatch } from 'react';
import { Action } from './actions';
import { initialState, messageReducer, MessageState } from './reducer';

type MessageContext = {
  state: MessageState;
  dispatch: Dispatch<Action>;
};

const messageContext = createContext<MessageContext>({
  state: initialState,
  dispatch: () => null,
});

export const useMessage = () => React.useContext<MessageContext>(messageContext);
export const MessageProvider: React.FC = ({ children }) => {
  const [state, dispatch] = React.useReducer(messageReducer, initialState);

  return (
    <messageContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </messageContext.Provider>
  );
};
